import axios from 'axios'
import {
    FOOTER_DATA_REQUEST,
    FOOTER_DATA_REQUEST_SUCCESS,
    FOOTER_DATA_REQUEST_FAIL
} from './footerConstants'

export const getFooterData = (lang) => async (dispatch) => {
    try {
        dispatch({ type: FOOTER_DATA_REQUEST })
        const { data } = await axios.get(`/api/footer/?lan=${lang}`)
        //console.log(localStorage.getItem("lang"));
        if (data.status === "ok") {
            dispatch({
                type: FOOTER_DATA_REQUEST_SUCCESS,
                payload: data.data
            })
        }
        else {
            dispatch({
                type: FOOTER_DATA_REQUEST_FAIL,
                payload: 'خطا در دریافت اطلاعات از سرور'
            })
        }
    } catch (error) {
        const err = error.response && error.response.data.message
            ? error.response.data.message
            : error.message
        console.error(err);
        dispatch({
            type: FOOTER_DATA_REQUEST_FAIL,
            payload: 'خطا در دریافت اطلاعات از سرور'
        })
    }
}